import React from 'react';
import AdminApiToken from './AdminApiToken';
import * as styles from './AdminApiView.module.scss';
import { Cards } from '../../components/Card';
import { PlanTier } from '../../graphql/generated/graphql';
import SettingsSection from '../../settings/SettingsSection';
import SettingsSectionUpsell from '../../settings/SettingsSectionUpsell';
import { useAllBots } from '../../user/useAllUsers';
import getFeature from '../../utils/features';
import Link from '../../utils/router/Link';

const AdminApiView = () => {
  const bots = useAllBots();

  if (!getFeature('api')) {
    return (
      <SettingsSectionUpsell
        header="API"
        feature="api"
        description="Upgrade to access the Slab API to build your own custom applications and integrations."
        minTier={PlanTier.Business}
        contentCards={
          <Cards>
            <AdminApiToken
              name="Slab"
              fakeToken="sk_live_tbQBLTsG4qQ8OjX4fxkv9G"
            />
            <AdminApiToken
              name="Zapier Helper"
              fakeToken="JDPzmN3vrvJHAGHVDh&"
            />
          </Cards>
        }
      />
    );
  }

  return (
    <SettingsSection
      header="API"
      subheader="Bot tokens can be used to access the Slab API. Like users, their access is governed by the the topics they are members of."
    >
      {bots.length > 0 && (
        <Cards>
          {bots.map(
            (bot) =>
              bot.id && (
                <AdminApiToken key={bot.id} id={bot.id} name={bot.name} />
              ),
          )}
        </Cards>
      )}
      <div className={styles.footer}>
        <div className={styles.footerContact}>
          <Link to="mailto:support@slab.com">Contact support</Link> to request
          additional bots
        </div>
        <Link to="https://go.slab.com/api-reference" newTab>
          API Reference
        </Link>
      </div>
    </SettingsSection>
  );
};

export default AdminApiView;
